export default __webpack_public_path__ + "static/media/VirusIcon.e47a3cbf.svg";